import { useEffect, useState } from 'react'
import { getOptionsByGroup, optionCodes, type TicketOption } from '@/lib/services/ticketOptionListService'

export function useTicketOptions(groupCode: string) {
  const [options, setOptions] = useState<TicketOption[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    setLoading(true)
    getOptionsByGroup(groupCode)
      .then((rows) => {
        if (!cancelled) setOptions(rows)
      })
      .catch(() => {
        if (!cancelled) setOptions([])
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })
    return () => {
      cancelled = true
    }
  }, [groupCode])

  return {
    options,
    codes: optionCodes(options),
    loading,
  }
}
